import Vue from 'vue'

export default {
    SET_LEADERS: (state, leaders) => {
        state.items = leaders
    },

    SET_ACCOUNT_ACTIVITY: (state, accountId) => {
        const accountIndex = state.items.findIndex(it => it.leaderId === accountId)
        const account = state.items[accountIndex]

        if (accountIndex !== -1) {
            Vue.set(account, 'disabled', !account.disabled)
        }
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    RESET_LEADERS: (state) => {
        state.filters = {
            leaderId: null,
            fromDate: null,
            toDate: null,
            leaderEmail: null,
            query: null
        }
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    }
}
